import type { FaqItem } from '../types/content';

export const faqItems: FaqItem[] = [
  {
    question: 'What is Vedic astrology?',
    answer:
      'Vedic astrology, or Jyotish, is the traditional system of astrology from India, thousands of years old. It uses the sidereal zodiac, aligned with the actual constellations, and places deep emphasis on timing: the planetary periods that shape each chapter of your life.',
  },
  {
    question: 'Why does my birth time matter?',
    answer:
      'Your birth time sets your rising sign and the position of all twelve houses, the areas of life your chart describes. Even a few minutes can shift them. If you are unsure, check your birth certificate or ask family. Abby can still read your chart without it, with less precision on houses and timing.',
  },
  {
    question: 'Phone or video?',
    answer:
      'Either. Every session is one hour, held by phone or video, worldwide. Choose whatever feels most comfortable; the depth of the reading is the same.',
  },
  {
    question: 'How often should I get a reading?',
    answer:
      'Quarterly is ideal. Your birth chart stays the same, but transits keep moving. A reading each season keeps you prepared for what is ahead. The Seasonal Membership is built around exactly that rhythm.',
  },
  {
    question: 'What is your reschedule and refund policy?',
    answer:
      'Policy wording is being finalized. Please contact us if you need to change your appointment.',
    need: 'reschedule / refund policy wording',
  },
];
